module.exports = __webpack_public_path__ + "img/gamifinnopolis.1347a49c.png";